import * as React from "react";
import { Textarea } from "./textarea";
import { cn } from "@/lib/utils";

// A Textarea that grows with its content so no text is ever hidden.
const AutoResizeTextarea = React.forwardRef(
  ({ value, className, minRows = 2, ...props }, forwardedRef) => {
    const innerRef = React.useRef(null);

    const setRefs = (node) => {
      innerRef.current = node;
      if (typeof forwardedRef === "function") forwardedRef(node);
      else if (forwardedRef) forwardedRef.current = node;
    };

    const resize = React.useCallback(() => {
      const el = innerRef.current;
      if (!el) return;
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }, []);

    React.useLayoutEffect(() => {
      resize();
    }, [value, resize]);

    return (
      <Textarea
        ref={setRefs}
        value={value}
        onInput={resize}
        rows={minRows}
        className={cn("resize-none overflow-hidden", className)}
        {...props}
      />
    );
  }
);
AutoResizeTextarea.displayName = "AutoResizeTextarea";

export { AutoResizeTextarea };
